import { Config } from 'config/envConfig';
import React, { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router';
import axios from '../utils/axiosConfig';
import { getUrl } from './pdfDisplay/utils';

const VerifyEmail = () => {
    const navigate = useNavigate();
    const { login, logout } = useAuth();
    // The verification link is single-use; never send it twice (StrictMode re-runs effects).
    const requested = useRef(false);

    useEffect(() => {
        if (requested.current) return;
        requested.current = true;

        const checkEmail = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            const dynamicUrl = getUrl(`http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/verify_mail`);
            try {
                // The response sets the session cookies and returns the same user shape as login.
                const response = await axios.get(dynamicUrl, { params: { token } });
                login(response.data);
                navigate('/chats');
            } catch {
                logout();
                navigate('/login');
            }
        };
        checkEmail();
    }, []);

    return <></>;
};

export default VerifyEmail;
